﻿import * as $ from 'jquery';
import { IResourceProvider } from 'common/resourceprovider';
import 'runtime/styles/errorreport.less';

export interface IErrorMessage {
    message?: string;
    additionalMessage?: string;
}

export class ErrorReport {
    private errors = <IErrorMessage[]>[];
    private currentErrorIndex = 0;

    private $dialog: JQuery;
    private $message: JQuery;
    private $additionalMessage: JQuery;
    private $prev: JQuery;
    private $next: JQuery;

    constructor(private resources: IResourceProvider, private title: string = null, private closeAction: () => void = () => { }) { }

    addError = (messageObject?: IErrorMessage): void => {
        this.errors.push(messageObject);

        if (!this.$dialog) {
            this.$dialog = this.makeDialog().dialog({
                appendTo: '.runtime-application-container',
                autoOpen: false,
                modal: true,
                title: this.title || this.resources.getCoreString('XamlRightCrowdErrorReport'),
                minWidth: 500,
                minHeight: 350,
                close: () => {
                    this.$dialog.dialog('destroy');
                    this.$dialog = null;
                    this.errors = [];
                    this.currentErrorIndex = 0;
                    this.closeAction();
                },
                buttons: [
                    {
                        text: this.resources.getCoreString('XamlPreviousError'),
                        click: this.prevError
                    },
                    {
                        text: this.resources.getCoreString('XamlNextError'),
                        click: this.nextError
                    },
                    {
                        text: this.resources.getCoreString('XamlClose'),
                        click: () => this.$dialog.dialog('close')
                    }
                ],
                open: (event: JQueryEventObject, ui: Object) => {
                    var $buttonSet = $('.ui-dialog-buttonset', this.$dialog.parent()).css('float', 'none');

                    var $buttons = $buttonSet.children('button').css('min-width', '100px');
                    this.$prev = $buttons.eq(0);
                    this.$next = $buttons.eq(1);
                    $buttons.eq(2).css('float', 'right');
                }
            });
            this.$dialog.dialog('open');
        }

        this.manageButtonState();
        this.showError(messageObject);
    };

    private makeDialog = (): JQuery => {
        this.$message = $('<div />');
        this.$additionalMessage = $('<div />');

        var $main = $('<div />').addClass('errorreport').append($('<div />').append([this.$message, this.$additionalMessage]));
        return $main;
    };

    private manageButtonState = (): void => {
        this.$prev.button((this.currentErrorIndex > 0) ? 'enable' : 'disable');
        this.$next.button((this.currentErrorIndex < this.errors.length - 1) ? 'enable' : 'disable');
    };

    private showError = (messageObject: IErrorMessage): void => {
        var message = (messageObject !== undefined && messageObject !== null && messageObject.message !== undefined) ? messageObject.message : this.resources.getCoreString('ErrSystemError');
        this.$message.text(message);

        var additionalMessage = (messageObject !== undefined && messageObject !== null && messageObject.additionalMessage !== undefined && messageObject.additionalMessage !== null) ? messageObject.additionalMessage : '';
        this.$additionalMessage.text(additionalMessage);
    }

    private nextError = (): void => {
        if (this.currentErrorIndex < this.errors.length - 1) {
            this.currentErrorIndex++;
            this.showError(this.errors[this.currentErrorIndex]);
            this.manageButtonState();
        }
    };

    private prevError = (): void => {
        if (this.currentErrorIndex > 0) {
            this.currentErrorIndex--;
            this.showError(this.errors[this.currentErrorIndex]);
            this.manageButtonState();
        }
    };
}